// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderStepUpdateStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/work_order_step_update_status/{step_id}
 *
 * Transition a work order step status.
 */
import { registerContract } from './validate'

export interface Orders_WorkOrderStepUpdateStatusInput {
status: string
}

registerContract('Orders_WorkOrderStepUpdateStatusInput', {
  status: { type: 'string',  required: true },
})
